import React from 'react'

export const Loader: React.FC = () => {
    return (
        <div className="preloader" >
            <div className="spinner"></div>
        </div>
    )
}

export default Loader
